<template>
  <div class="profil-container" v-if="registrasi.length > 0">
    <h3 class="profil-title" v-if="formIsActive(registrasi[0])">{{ registrasi[0].text }}</h3>
    <div class="instruction-wrapper flex-row" v-if="formIsActive(registrasi[1])">
      <div class="flex-col">
        <div v-for="(item, index) in instructions" :key="index" class="instruction-list">
          <div class="instruction-number">{{ index + 1 }}.</div>
          <div class="instruction-text" v-html="highlightStars(item)"></div>
        </div>
      </div>

    </div>

    <div class="profil-btn-wrapper">
      <div @click="goProfile()" class="btn-landing">Selanjutnya</div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    instructions() {
      return this.splitText(this.registrasi[1].text);
    },
    registrasi() {
      const data = this.$store.state.landingpage.md_step_1
      return data
    }
  },
  methods: {
    goProfile() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'profilebu')
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'profil_step',
        value: true,
      })
    },
    splitText(text) {
      return text.split(/\d+\./).filter(item => item.trim());
    },
    highlightStars(text) {
      return text.replace(/\*/g, "<span style='color: red;'>*</span>");
    },
  }
}
</script>
